export default function useAuxInput(
  key: string,
  subfolder: string | undefined = undefined
) {
  const exists = ref(false);
  const component = shallowRef(null);

  // Check if component exists and cache the result
  const checkComponent = async () => {
    if (!key) {
      exists.value = false;
      component.value = null;
      return;
    }

    try {
      // Need to use full path otherwise vite will complain about dynamic imports
      if (subfolder) {
        const comp = await import(
          `~/components/dynamic/${subfolder}/${key}.vue`
        );
        exists.value = true;
        component.value = defineAsyncComponent(
          () => import(`~/components/dynamic/${subfolder}/${key}.vue`)
        );
      } else {
        const comp = await import(`~/components/dynamic/${key}.vue`);
        exists.value = true;
        component.value = defineAsyncComponent(
          () => import(`~/components/dynamic/${key}.vue`)
        );
      }
    } catch {
      console.log(
        `Component not found for subfolder: ${subfolder}, key: ${key}`
      );
      exists.value = false;
      component.value = null;
    }
  };

  // Check on creation and when key changes
  watch(() => key, checkComponent, { immediate: true });

  const get = computed(() => component.value);

  return {
    exists: readonly(exists),
    get,
  };
}
